module.exports = __webpack_public_path__ + "90e9f73abaa206455171084b6475ca69.svg";